<template>
  <tr>
    <td class="text-center">{{ item.ARTICULO.CDU }}</td>
    <td class="p0">
      <table 
        class="table c-tbl-sus subtable" 
        :style=" { border: item.NUIDLPP == null ? '2px solid black' : '2px solid transparent' }"
      >
        <tr>
          <td colspan="2" width="50%" class="descatalogado">
            <span class="c-tbl-sus-title">{{ $t('Título') }}</span>
            {{ item.ARTICULO.TITULO }}
          </td>
          <td colspan="2" width="50%" class="propuesta">
            <template v-if=" isEditable ">
              <input v-model="propuesta.TITULO" type="text" class="form-control mt3" :placeholder="$t('Título')" maxlength="150" >
            </template>              
            <template v-else>
              <span class="c-tbl-sus-title">{{ $t('Título') }}</span>
              {{ item.SUSTITUCION.TITULO }}
            </template>
          </td>
        </tr>

        <tr>
          <td colspan="2" class="descatalogado">
            <span class="c-tbl-sus-title">{{ $t('Autor') }}</span>
            {{ item.ARTICULO.AUTOR }}
          </td>
          <td colspan="2" class="propuesta">
            <template v-if=" isEditable ">
              <input v-model="propuesta.AUTOR" type="text" class="form-control mt3" :placeholder="$t('Autor')" maxlength="150">
            </template>              
            <template v-else>
              <span class="c-tbl-sus-title">{{ $t('Autor') }}</span>
              {{ item.SUSTITUCION.AUTOR }}
            </template>
          </td>
        </tr>

        <tr>
          <td colspan="2" class="descatalogado">
            <span class="c-tbl-sus-title">{{ $t('Editor') }}</span>
            {{ item.ARTICULO.EDITOR }}
          </td>
          <td colspan="2" class="propuesta">
            <template v-if=" isEditable ">
              <input v-model="propuesta.EDITOR" type="text" class="form-control mt3" :placeholder="$t('Editor')" maxlength="150">
            </template>              
            <template v-else>
              <span class="c-tbl-sus-title">{{ $t('Editor') }}</span>
              {{ item.SUSTITUCION.EDITOR }}
            </template>
          </td>
        </tr>

        <tr>                
          <td width="35%" class="descatalogado">
            <span class="c-tbl-sus-title">{{ $t('Código') }}</span>
            {{ item.ARTICULO.CODIGO }}
          </td>
          <td width="15%" class="descatalogado">
            <span class="c-tbl-sus-title">{{ $t('Año') }}</span>
            {{ item.ARTICULO.ANO }}
          </td>                
          <td width="35%" class="propuesta p-relative">
            <div v-if=" loadingCode " class="td-loading"></div>
            <template v-if=" isEditable ">
              <input v-model="propuesta.CODIGO" @keyup.enter="searchCode" type="text" class="form-control mt3" :placeholder="$t('Código')" maxlength="150">
            </template>              
            <template v-else>
              <span class="c-tbl-sus-title">{{ $t('Código') }}</span>
              {{ item.SUSTITUCION.CODIGO }}
            </template>
          </td>
          <td width="15%" class="propuesta">
            <template v-if=" isEditable ">
              <input v-model="propuesta.ANO" type="text" class="form-control mt3" :placeholder="$t('Año')" maxlength="150">
            </template>              
            <template v-else>
              <span class="c-tbl-sus-title">{{ $t('Año') }}</span>
              {{ item.SUSTITUCION.ANO }}
            </template>
          </td>  
        </tr>

        <tr>
          <td colspan="2" class="descatalogado">
            <span class="c-tbl-sus-title">{{ $t('Situación') }}</span>
            {{ item.SITUACION }}          
          </td>
          <td colspan="2" class="propuesta">
            <span class="c-tbl-sus-title">{{ $t('Comentario') }}</span>
            <template v-if=" (state == 'SIN_PROPUESTA' && getUserRole == 'admin' ) || (state == 'RECHAZADO' && getUserRole == 'admin' )">
              <textarea v-model="propuesta.COMENTARIOS" rows="2" class="form-control" style="width: 100%" :placeholder="$t('Escribe tu comentario')"></textarea>
            </template>   
            <template v-if=" state == 'PENDIENTE' ">
              <textarea v-model="item.SUSTITUCION.COMENTARIOS" rows="2" class="form-control" style="width: 100%" :placeholder="$t('Escribe tu comentario')"></textarea>
            </template>
            <template v-if=" state != 'PENDIENTE' && state != 'RECHAZADO' ">
              {{ item.SUSTITUCION.COMENTARIOS }} &nbsp;
            </template>
          </td>
        </tr>
      </table>
    </td>

    <td class="text-center">
      <div v-if=" (state == 'PENDIENTE' || state == 'ACEPTADO') && getUserRole != 'admin' ">
        {{ parseInt(item.SUSTITUCION.EDICION_POSTERIOR) ? 'Si' : 'No' }}
      </div>
      <div v-if=" (state == 'SIN_PROPUESTA' || state == 'RECHAZADO' || state == 'PENDIENTE') && getUserRole == 'admin' ">
        <div @click="toggleEdicionPosterior()" class="check">
          <i v-if=" propuesta.EDICION_POSTERIOR == '1' " class="fa fa-check-square-o"></i>
          <i v-else class="fa fa-square-o"></i>
        </div>
      </div>      
    </td>

    <td class="text-center">
      <div v-if=" state == 'PENDIENTE' " @click="toggleCheck('ACEPTADO')" class="check">
        <i v-if=" item.ESTADO == 'ACEPTADO' " class="fa fa-check-square-o"></i>
        <i v-else class="fa fa-square-o"></i>
      </div>
      <div v-if=" (state == 'SIN_PROPUESTA' || state == 'RECHAZADO' || state == 'PENDIENTE') && getUserRole == 'admin' ">
        <div v-if=" item.NUIDLPP == null " class="loading center"><img src="@/assets/img/loading-mini.gif" alt=""></div>
        <button
          v-else
          @click="propose()" 
          :disabled=" !isProposeValid "
          title="Todos los campos excepto comentarios son obligatorios"
          class="btn btn-black"><i class="fa fa-save" style="margin-right: 0"
        ></i></button>
      </div>
    </td>

    <td class="text-center">
      <div v-if=" state == 'PENDIENTE' " @click="toggleCheck('RECHAZADO')" class="check">
        <i v-if=" item.ESTADO == 'RECHAZADO' " class="fa fa-check-square-o"></i>
        <i v-else class="fa fa-square-o"></i>
      </div>              
    </td>         
    
  </tr>
</template>

<script>
  import axios from 'axios'; 
  
  import { mapGetters } from 'vuex';

  export default {
    props: {
      item: {
        type: Object,
        default: () => {}
      },
      state: {
        type: String,
        default: ''
      }
    },
    data: () => {
      return{
        loadingCode: false,
        propuesta: {
          TITULO: '',
          AUTOR: '',
          EDITOR: '',
          CODIGO: '',
          ANO: '',
          COMENTARIOS: '',
          EDICION_POSTERIOR: 0,
          NUIDLPP: null
        }
      }
    },
    mounted(){
      if( this.state == 'RECHAZADO' || this.state == 'PENDIENTE' ){
        this.propuesta = Object.assign({}, this.item.SUSTITUCION)
      }
    },
    computed: {
      ...mapGetters(['getUserRole', 'getLocale', 'getApiUrl']),
      isEditable: function(){
        return (this.getUserRole == 'admin' && ( this.state == 'RECHAZADO' || this.state == 'SIN_PROPUESTA' || this.state == 'PENDIENTE' ) ) ? 1 : 0
      },
      isProposeValid: function () {
        if(
          this.propuesta.TITULO.length >= 3 &&
          this.propuesta.AUTOR.length >= 3 &&
          this.propuesta.EDITOR.length >= 3 &&
          this.propuesta.CODIGO.length >= 3 &&
          this.propuesta.ANO.length >= 3
        ){
          return true
        }else{
          return false
        }
      }
    },
    methods: {
      toggleCheck(type) {
        if( type == 'ACEPTADO' && this.item.ESTADO != 'ACEPTADO' ){
          this.item.ESTADO = 'ACEPTADO'
        }else if( type == 'ACEPTADO' && this.item.ESTADO == 'ACEPTADO' ){
          this.item.ESTADO = 'PENDIENTE'
        }else if( type == 'RECHAZADO' && this.item.ESTADO != 'RECHAZADO' ){
          this.item.ESTADO = 'RECHAZADO'
        }else if( type == 'RECHAZADO' && this.item.ESTADO == 'RECHAZADO' ){
          this.item.ESTADO = 'PENDIENTE'
        }
      },
      toggleEdicionPosterior(){
        this.propuesta.EDICION_POSTERIOR = parseInt(this.propuesta.EDICION_POSTERIOR) ? 0 : 1
      },
      propose(){
        //console.log(this.item)

        if( this.isProposeValid ){
          this.propuesta.NUIDLPP = this.item.NUIDLPP
          this.$emit('sendPropuesta', this.propuesta)
        }        
      },
      searchCode(){
        this.loadingCode = true
        // this.propuesta.CODIGO
        /* setTimeout(() => {
          this.loadingCode = false
        }, 500); */

        axios.get( this.getApiUrl + this.getLocale + '/misconsultas/sustituciones/codigo?CODIGO=' + this.propuesta.CODIGO )
          .then( (respuesta) =>{ 
            //console.log(respuesta.data)
            if( respuesta.data.data != false ){
              this.propuesta.TITULO = respuesta.data.data.TITULO
              this.propuesta.AUTOR = respuesta.data.data.AUTOR
              this.propuesta.EDITOR = respuesta.data.data.EDITOR
              this.propuesta.ANO = respuesta.data.data.ANO
              this.propuesta.EDICION_POSTERIOR = 0
            }else{
              this.propuesta.TITULO = ''
              this.propuesta.AUTOR = ''
              this.propuesta.EDITOR = ''
              this.propuesta.ANO = ''
              this.propuesta.EDICION_POSTERIOR = 0
            }

            this.loadingCode = false
          })
        .catch( (error) =>{ 
          this.propuesta.EDICION_POSTERIOR = 0
          this.loadingCode = false
          alert(error.response.data.msg)
        });


      }
    },
    watch: {
      item(newValue, oldValue) {
        //console.log(newValue)
        if( this.state == 'RECHAZADO' ){
          this.propuesta = Object.assign({}, newValue.SUSTITUCION)
        }else {
          this.propuesta.TITULO = ''
          this.propuesta.AUTOR = ''
          this.propuesta.EDITOR = ''
          this.propuesta.CODIGO = ''
          this.propuesta.ANO = ''
          this.propuesta.COMENTARIOS = ''
          this.propuesta.EDICION_POSTERIOR = 0
          this.propuesta.NUIDLPP = null
        }
      }
    },
  }
</script>

<i18n>
  {
    "es": {
      "Título": "Título",
      "Autor": "Autor",
      "Editor": "Editor",
      "Código": "Código",
      "Año": "Año",
      "Situación": "Situación",
      "Comentario": "Comentario",
      "Escribe tu comentario": "Escribe tu comentario"
    },
    "ca": {
      "Título": "Títol",
      "Autor": "Autor",
      "Editor": "Editor",
      "Código": "Codi",
      "Año": "Any",
      "Situación": "Situació",
      "Comentario": "Comentari",
      "Escribe tu comentario": "Escriu el teu comentari"
    }
  }
</i18n>